import { cn } from "@reactive-resume/utils";

import type { TemplateCategory, TemplateCategoryOption } from "../data/templates";

type TemplatesPageHeaderProps = {
  title: string;
  description: string;
  categories: TemplateCategoryOption[];
  selectedCategory: TemplateCategory;
  onCategoryChange: (category: TemplateCategory) => void;
};

export const TemplatesPageHeader = ({
  title,
  description,
  categories,
  selectedCategory,
  onCategoryChange,
}: TemplatesPageHeaderProps) => {
  return (
    <header>
      <div className="max-w-2xl">
        <h1 className="text-xl font-bold tracking-tight text-indigo-950 sm:text-2xl">{title}</h1>

        <p className="mt-1 text-xs leading-5 text-slate-600 sm:text-[13px]">{description}</p>
      </div>

      <div
        role="tablist"
        aria-label="Catégories de modèles"
        className={cn(
          "mt-4 flex gap-2 overflow-x-auto pb-1",
          "[scrollbar-width:none]",
          "[&::-webkit-scrollbar]:hidden",
        )}
      >
        {categories.map((category) => {
          const isSelected = selectedCategory === category.value;

          return (
            <button
              key={category.value}
              type="button"
              role="tab"
              aria-selected={isSelected}
              onClick={() => {
                onCategoryChange(category.value);
              }}
              className={cn(
                "min-h-9 shrink-0 rounded-xl border",
                "px-3 text-[11px] font-semibold",
                "transition-all duration-200",
                "focus-visible:outline-none",
                "focus-visible:ring-2",
                "focus-visible:ring-indigo-500",
                "sm:px-4 sm:text-xs",
                isSelected
                  ? "border-indigo-600 bg-indigo-600 text-white shadow-sm"
                  : "border-slate-200 bg-white text-indigo-950 hover:border-indigo-300 hover:bg-indigo-50",
              )}
            >
              {category.label}
            </button>
          );
        })}
      </div>
    </header>
  );
};
